export default {
   data(){
      return {
         headerPrepareInfo :  ` Sample Information `,
         findingAndContent :  ` Findings And Comments`,
         images_title : ` Images`,
         ClassificationOfDiseases :  `Classification of Diseases ` ,
         headerPrepareInfoPlus : ``,  // ` Sample Information Plus`,
         findingAndContentPlus :  ` Findings And Contents Plus`,
         ImagePlus :  ` Images Plus`,
         DiagnosisPlus : ` Diagnosis Plus`,
         RequestedInfo : ` Request Information`,

         headerInfoPrepare :  ` Sample Information `,
         headerInfoPreparePlus :  ` Header Info. Prepare Plus`,

         PathogenSelect  :` Pathogen ` ,
         BacterialSelect :` Bacterial Culture` ,
         OrganismSelect :` Organism Culture` ,
         ParasiteSelect :` Parasite Examination` ,

         levelDxLabel : ['Chapter' ,  'Body System' , 'Organ/Tissue'  ,  'Character/Subcategories'  ,  'Extensions']  ,



         // pathogenTitle :   ` Result PCR `,
         resultPCRTitle :   ` Result PCR `,
         COLOR_CELL_PLUS :  ` has-background-danger-light`,
         COLOR_CELL_NORMAL :  ` `,
         customToolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            // ["image", "code-block"],
            [ "code-block"],
            [{ 'color': [] }, { 'background': [] }],
            ['link'],
         ],

         SUBMIT_TYPE_PLUS_EDIT : {
            prepare : "prepare",
            ct : "ct"
         },

         TYPE_TO_DELETE_NONAUTOMATE :{
            prepare : "prepare",
            prepare_plus : "prepare_plus",
            ct : "ct" ,
            ct_plus : "ct_plus" ,
            images : "images",
            images_plus : "images_plus",
            diag_code : "diag_code" ,
            diag_code_plus : "diag_code_plus",
            pcr_pathogen : 'pcr_pathogen',
            pcr_pathogen_plus : 'pcr_pathogen_plus',
            bact_data : 'bact_data',
            bact_data_plus : 'bact_data_plus'
         }
         // submitTypePlusEdit : {
         //    prepare : "prepare",
         //    ct : "ct"
         // }
      }
   }

}